<template>
  <div class="nav" :class="lan == 'ar' ? 'ar' : ''">
    <ul>
      <!-- <li class="back">
        <router-link to="/home" >
          <img v-show="showBack" src="../assets/images/back.png" alt="" />
        </router-link>
      </li> -->
      <!-- <li :class="router == 'home' ? 'active' : ''">
        <router-link to="/home">{{ $t("message.strid1") }}</router-link>
      </li> -->

      <li :class="router == 'tutorials' ? 'active' : ''">
        <router-link to="/tutorials">{{ $t("message.strid2") }}</router-link>
      </li>

      <li :class="router == 'activity' ? 'active' : ''">
        <router-link to="/activity">{{ $t("message.strid3") }}</router-link>
      </li>

      <!-- <li @click="open" class="join">
        <img src="../assets/images/join_us.png" alt="" srcset="" />
        <p>{{ $t("message.strid4") }}</p>
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
  props: ["showBack", "router", "lan"],
  data() {
    return {};
  },
  methods: {
    open() {
      this.$emit("open");
    },
  },
};
</script>

<style lang="scss" >
</style>
